import { __rest } from "tslib";
import { createElement, forwardRef, useContext } from 'rax';
import Button from '../button/button';
import Context from './context';
const Submit = forwardRef((props, ref) => {
    const { onClick, validate = true, children } = props, other = __rest(props, ["onClick", "validate", "children"]);
    const { form, size } = useContext(Context);
    const handleClick = () => {
        if (form) {
            form.submit((value, errors, field) => {
                if (onClick) {
                    onClick(value, errors, field);
                }
            }, !validate);
        }
    };
    return (<Button ref={ref} size={size} {...other} onClick={handleClick}>
      {children}
    </Button>);
});
export default Submit;
